import {
  postersFetchAPoster,
  postersSetPostersFilter,
  postersReset,
  postersSetExcludedPosterIds,
  postersGetDateString,
  postersGetEndDateOrTime
} from "./posters.js";

import { posterFetchPosterData } from "./poster.js";

import { tagsTopLabels } from "./tags.js";
import { browserGetBrowserHeight, browserGetBrowserWidth } from "./browser.js";
import { i18nNormalizeLanguage, i18nText } from "./i18n.js";
import { mapsLocalizePath, mapsRegion, mapsTown } from "./maps.js";
import { labelsGetDisplayLabel } from "./labels.js";
import { empGetEditorUrl } from "./emp.js";

let map;
let mapPostersMaximumDate;
let mapPostersFetching = false;
const mapPostersResolveValue = [];
let mapPosterIndex;
let mapPosterModal;
let mapCurrentDisplayedPoster = null;
const mapMarkersLocation = [];
const mapMarkers = [];
const mapFilterLabel = [""];
let mapLat = 41.7;
let mapLng = 1.5;
let mapZoom = 8;

let AdvancedMarkerElement;

function mapGetForcedPosterParams() {
  const params = new URL(document.location).searchParams;
  const posterId = params.get("posterId");
  const posterParent = params.get("posterParent");
  if (!posterId || !posterParent) {
    return null;
  }
  return {
    posterId,
    posterParent,
    rawPosterId: posterId
  };
}

function mapEscapeHtml(value) {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

function mapGetPosterHref(poster) {
  return mapsLocalizePath(
    "/" +
      encodeURIComponent(poster.id) +
      ".html?id=" +
      encodeURIComponent(poster.publisherId),
    i18nNormalizeLanguage(poster.contentLanguage)
  );
}

function mapRenderPosterSummary(poster) {
  const content = document.getElementById("mapWindowInfoContent");
  if (!content) {
    return;
  }
  const posterLanguage = i18nNormalizeLanguage(poster.contentLanguage);
  const text = i18nText(posterLanguage);

  const subtitle =
    poster.subtitle && poster.subtitle.trim() !== ""
      ? `<p class="mapPosterSubtitle">${mapEscapeHtml(poster.subtitle)}</p>`
      : "";

  const dateLine =
    postersGetDateString(poster.dateBegin, posterLanguage) +
    " " +
    postersGetEndDateOrTime(
      poster.dateBegin,
      poster.dateEnd,
      poster.timeBegin,
      posterLanguage
    );

  content.innerHTML =
    `<div class="mapPosterCard">` +
    `<h2 class="mapPosterTitle">${mapEscapeHtml(poster.title)}</h2>` +
    subtitle +
    `<p class="mapPosterMeta">${mapEscapeHtml(dateLine)}</p>` +
    `<p class="mapPosterMeta"><a class="mapPosterMetaLink" href="${mapsTown(
      poster.region,
      poster.town
    )}">${mapEscapeHtml(poster.town)}</a> · <a class="mapPosterMetaLink" href="${mapsRegion(
      poster.region
    )}">${mapEscapeHtml(poster.region)}</a></p>` +
    `<a class="mapPosterLink" href="${mapGetPosterHref(poster)}">${text.morePosterInfo}</a>` +
    `</div>`;
}

function mapAddPosterToQueue(poster) {
  mapPostersResolveValue.push({ index: null, poster });
  mapMarking();
}

function mapFetchForcedPoster(params) {
  posterFetchPosterData(params.posterParent, params.posterId)
    .then((poster) => {
      mapAddPosterToQueue(poster);
    })
    .catch((err) => {
      console.log("Fetch forced Map poster error: ", err);
    });
}

function mapFetchPoster() {
  mapPostersFetching = true;
  postersFetchAPoster(null, null)
    .then((th) => {
      if (th.poster !== null) {
        const parts = th.poster.dateBegin.split("/");
        const ddate = new Date(parts[2], parts[1] - 1, parts[0]);
        if (ddate < mapPostersMaximumDate) {
          mapFetchPoster();
          mapPostersResolveValue.push(th);
        } else {
          mapPostersFetching = false;
        }
      } else {
        mapPostersFetching = false;
      }

      if (mapPostersFetching === false && mapPostersResolveValue.length === 0) {
        let message = "No hi ha cartells";
        if (mapFilterLabel[0] !== "") {
          message += ", amb l'etiqueta '" + labelsGetDisplayLabel(mapFilterLabel[0], document.documentElement.lang === "es" ? "es" : "ca") + "',";
        }
        const radios = document.getElementsByName("days");
        for (let i = 0; i < radios.length; i++) {
          if (radios[i].checked) {
            message += " en els prÃ²xims " + radios[i].value + " dies.";
            break;
          }
        }
        message +=
          "<br><br>Pot penjar el teu cartell a <a href='" + empGetEditorUrl() + "'>editor.yuppiya.com</a>";
        document.getElementById("mapInfoErrorContent").innerHTML = message;
        const modal = document.getElementById("mapWindowError");
        modal.style.display = "inline-block";

        if (browserGetBrowserWidth() > 640) {
          modal.style.left = (browserGetBrowserWidth() - 640) / 2 + "px";
          modal.style.top = "45px";
        } else {
          modal.style.left = "0px";
          modal.style.right = "0px";
          modal.style.top = "45px";
        }
      }
    })
    .catch((err) => {
      console.log("Fetch Map posters error: ", err);
      mapPostersFetching = false;
    });
}

function mapSetPostersMaximunDays(days) {
  const now = new Date();
  mapPostersMaximumDate = now.setDate(now.getDate() + days);
}

function mapFetchPosters(modal) {
  mapSetPostersMaximunDays(30);
  mapPosterModal = modal;

  const forcedParams = mapGetForcedPosterParams();
  if (forcedParams) {
    postersSetExcludedPosterIds([forcedParams.rawPosterId]);
    mapFetchForcedPoster(forcedParams);
  } else {
    postersSetExcludedPosterIds(null);
  }

  mapFetchPoster();
}

function mapRefetchPostersAndMarkThem() {
  document.getElementById("mainLoader").style.display = "inline-block";

  mapMarkersLocation.length = 0;
  mapMarkers.forEach((marker) => {
    marker.setMap(null);
  });
  mapMarkers.length = 0;
  mapPostersResolveValue.length = 0;
  mapPosterIndex = 0;
  mapCurrentDisplayedPoster = null;
  mapPosterModal.style.display = "none";

  postersReset();
  postersSetPostersFilter(mapFilterLabel[0]);

  const forcedParams = mapGetForcedPosterParams();
  if (forcedParams) {
    postersSetExcludedPosterIds([forcedParams.rawPosterId]);
    mapFetchForcedPoster(forcedParams);
  } else {
    postersSetExcludedPosterIds(null);
  }

  mapFetchPoster();
  mapMarking();
}

function mapGetSpriteOffset(labels) {
  if (labels.includes(tagsTopLabels[1])) return { x: 0, y: 55 };
  else if (labels.includes(tagsTopLabels[0])) return { x: 110, y: 0 };
  else if (labels.includes(tagsTopLabels[2])) return { x: 220, y: 0 };
  else if (labels.includes(tagsTopLabels[3])) return { x: 0, y: 0 };
  else if (labels.includes(tagsTopLabels[4])) return { x: 55, y: 0 };
  else if (labels.includes(tagsTopLabels[5])) return { x: 165, y: 0 };
  else if (labels.includes(tagsTopLabels[6])) return { x: 110, y: 55 };
  else return { x: 55, y: 55 };
}

function mapMarking() {
  if (
    mapPostersFetching === false &&
    mapPosterIndex >= mapPostersResolveValue.length
  ) {
    document.getElementById("mainLoader").style.display = "none";
    return;
  }
  if (mapPosterIndex < mapPostersResolveValue.length) {
    let lat = mapPostersResolveValue[mapPosterIndex].poster.geoPt.latitude;
    let lng = mapPostersResolveValue[mapPosterIndex].poster.geoPt.longitude;
    let position;
    while (1) {
      const aux = mapMarkersLocation.some((marker) => {
        return marker.lat === lat && marker.lng === lng;
      });
      if (aux === false) {
        position = { lat, lng };
        mapMarkersLocation.push(position);
        break;
      }
      lat += 0.0001;
      lng += 0.0001;
    }

    let auxArray;
    if (mapFilterLabel[0] !== "") {
      auxArray = mapFilterLabel;
    } else {
      auxArray = mapPostersResolveValue[mapPosterIndex].poster.labelsList;
    }

    const offset = mapGetSpriteOffset(auxArray);
    const iconUrl = "/images/markers.png";

    const markerElement = document.createElement("div");
    markerElement.className = "custom-marker";
    markerElement.style.backgroundImage = `url(${iconUrl})`;
    markerElement.style.width = "55px";
    markerElement.style.height = "55px";
    markerElement.style.backgroundPosition = `-${offset.x}px -${offset.y}px`;

    const poster = mapPostersResolveValue[mapPosterIndex].poster;

    const advancedMarker = new AdvancedMarkerElement({
      position: position,
      content: markerElement,
      map: map,
      title: poster.title
    });

    advancedMarker.addListener(
      "click",
      (() => {
        return () => {
          mapCurrentDisplayedPoster = poster;
          mapRenderPosterSummary(poster);
          mapPosterModal.style.display = "inline-block";
        };
      })()
    );

    mapMarkers.push(advancedMarker);
    mapPosterIndex++;
  }
  setTimeout(mapMarking, 0);
}

async function mapInit() {
  const params = new URL(document.location).searchParams;
  mapLat = parseFloat(params.get("lat")) || mapLat;
  mapLng = parseFloat(params.get("lng")) || mapLng;
  mapZoom = parseInt(params.get("zoom")) || mapZoom;

  const mapElement = document.getElementById("map");
  const resizeMap = () => {
    const headerHeight = document.getElementById("mainHeader")?.offsetHeight || 56;
    const legendHeight = document.getElementById("mapLegendLabels")?.offsetHeight || 50;
    mapElement.style.height = browserGetBrowserHeight() - headerHeight - legendHeight + "px";
  };
  resizeMap();
  mapElement.style.width = "100%";

  window.addEventListener("resize", function () {
    resizeMap();
  });

  const { Map } = await google.maps.importLibrary("maps");
  const markerLibrary = await google.maps.importLibrary("marker");
  AdvancedMarkerElement = markerLibrary.AdvancedMarkerElement;

  map = new Map(mapElement, {
    center: { lat: mapLat, lng: mapLng },
    zoom: mapZoom,
    mapId: "POSTERS_ID"
  });
  mapPosterIndex = 0;

  mapMarking();

  if (browserGetBrowserWidth() > 640) {
    mapPosterModal.style.left = (browserGetBrowserWidth() - 640) / 2 + "px";
    mapPosterModal.style.top = "3px";
  } else {
    mapPosterModal.style.left = "0px";
    mapPosterModal.style.top = "0px";
  }

  const close = document.getElementById("mapWindowInfoClose");
  close.addEventListener("click", (event) => {
    event.preventDefault();
    mapPosterModal.style.display = "none";
  });

  const radios = document.getElementsByName("days");
  [].forEach.call(radios, (radio) => {
    radio.addEventListener("change", (event) => {
      if (event.target.checked) {
        mapSetPostersMaximunDays(parseInt(event.target.value));
        mapRefetchPostersAndMarkThem();
      }
    });
  });

  const legend = document.getElementById("mapLegend");
  map.controls[google.maps.ControlPosition.LEFT_CENTER].push(legend);

  const radios2 = document.getElementsByName("labelFilter");
  radios2.forEach((radio2) => {
    if (!radio2.onchange) {
      radio2.addEventListener("change", (event) => {
        mapRadioLabelFilterChange(event);
      });
    }
  });
}

function mapRadioLabelFilterChange(event) {
  if (event.target.checked) {
    mapFilterLabel[0] = event.target.value;
    mapRefetchPostersAndMarkThem();
  }
}

export { mapInit, mapFetchPosters, mapRadioLabelFilterChange };
